<template>
  <v-container class="fill-height back" fluid>
    <v-app-bar clipped-left app flat dark color="transparent">
      <img @click="home" class="logo" height="36" src="https://irsx.sgp1.digitaloceanspaces.com/irmalogoputih.png"/>
      <v-spacer/>
      <v-toolbar-items>
        <v-btn text>Fitur</v-btn>
        <v-btn @click="login" text>Login</v-btn>
        <v-btn @click="register" text>Register</v-btn>
      </v-toolbar-items>
    </v-app-bar>
      <v-layout align-center justify-center>
          <v-flex xs12 sm6 md6 lg6>
             <v-card class="elevation-2">
               <v-layout wrap>
                 <div class="primary layout align-center hidden-sm-and-down">
                   <v-img
                          src="../assets/imagelogin.png"
                          alt="irma"
                          max-height="300"
                          contain
                          width="300">
                   </v-img>
                 </div>
                 <v-flex xs12 sm12 md12 lg6>
                   <h1 class="text-center primary--text mt-5">Login App Console</h1>
                   <v-card-text>
                     <v-form v-model="valid" ref="form" lazy-validation @submit.prevent="handleSubmit()">
                       <v-text-field
                               v-model="email"
                               name="email"
                               data-vv-name="email"
                               type="email"
                               :rules="emailRules"
                               required
                               label="Email"
                       ></v-text-field>
                       <v-text-field
                               v-model="password"
                               data-vv-name="password"
                               name="password"
                               required
                               :rules="passwordRules"
                               label="Password"
                               type="password"
                               @keypress="keyturun"
                       ></v-text-field>
                       <v-card-actions>


                         <v-spacer></v-spacer>
                         <v-btn block class="primary" @click.native="handleSubmit()" :loading="loading">Login</v-btn>
                       </v-card-actions>
                       <div style="height:20px"></div>
                       <a href="#" class="" @click.prevent="forgot()">Forgot Password </a>
                       <v-spacer></v-spacer>
                       <a href="#" class="" @click.prevent="register()">Create New Account </a>
                       <div style="height:20px"></div>
                     </v-form>
                   </v-card-text>
                 </v-flex>
               </v-layout>
             </v-card>
          </v-flex>
      </v-layout>
    </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'LoginPage',
  data () {
    return {
      valid: false,
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v =>
          // eslint-disable-next-line no-useless-escape
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          'E-mail must be valid'
      ],
      password: '',
      passwordRules: [v => !!v || 'Password is required'],
      submitted: false,
      items: [
        {
          src: '/static/banner/banner0.jpg'
        },
        {
          src: '/static/banner/banner2.jpg'
        }
      ]
    }
  },
  computed: {
    ...mapState('authentication', ['status', 'loading'])
  },
  created () {
    // reset login status
    //this.logout()
  },
  methods: {
    ...mapActions('authentication', ['dologin', 'logout']),
    handleSubmit () {
      this.submitted = true
      const { email, password } = this
      if (email && password) {
        this.dologin({ email, password })
      }
    },
    keyturun(e){
      if(e.code==='Enter'){
        this.handleSubmit()
      }
    },
    register () {
      this.$router.push('/register')
    },
    forgot () {
      this.$router.push('/forgot')
    },
    home(){
      this.$router.push('/')
    },
    login(){
      this.$router.push("/login")
    },
  }
}
</script>

<style scoped>
  .back {
    background-image: linear-gradient(to right, rgba(5, 11, 31, 0.8), rgba(5, 11, 31, 0.8)), url("https://irsx.sgp1.digitaloceanspaces.com/bglogintech.jpeg");
    background-size: cover;
  }
  a {
    text-decoration: none;
  }
</style>
